import currentGameProgress from "@core/services/common/game/graphql/currentGameProgress.graphql";
import saveGameProgress from "@core/services/common/game/graphql/saveGameProgress.graphql";
import { GameModalState } from "@core/store/types/common/game/gameModal";
import Service from "@core/services/common/Service";

export class GameModalService extends Service {
  public static async saveGameProgress (points: number, context: Record<string, any>) {
    await this.api.get("", {
      params: {
        query: saveGameProgress,
        variables: { points, context }
      }
    });
  }
  public static async getCurrentGameProgress (): Promise<GameModalState["data"]> {
    const { data: { currentGameProgress: data } } = await this.api.get("", {
      params: { query: currentGameProgress }
    });
    return data;
  }
}
